/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Run_AnswerInputs */

const en_inbox_na_run_answer = /** @type {(inputs: Inbox_Na_Run_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer the question`)
};

const id_inbox_na_run_answer = /** @type {(inputs: Inbox_Na_Run_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jawab pertanyaan`)
};

/**
* | output |
* | --- |
* | "Answer the question" |
*
* @param {Inbox_Na_Run_AnswerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_run_answer = /** @type {((inputs?: Inbox_Na_Run_AnswerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Run_AnswerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_run_answer(inputs)
	return en_inbox_na_run_answer(inputs)
});